const Planet = ({planetKey, weight, gravity ,planetName}) => {

    return (
        <>
            <div key={planetKey} className={`planet ${planetName.toLowerCase()}`}>
                <h4>{planetName}</h4>
                <p>Your weight: {(weight * gravity).toFixed(2)}</p>
            </div>
        </>
    ) 
}

export default Planet;